import * as React from 'react'
import { connect } from 'react-redux'
import type { EmailCampaign } from 'types/campaign'
import type { State } from 'types/redux'
import { campaignDetailsUpdate } from '@disco/state-management/actions/campaign-details-actions'
import {
  getCampaign,
  getValidCampaignSteps,
} from '@disco/state-management/selectors/campaigns'
import { TabStepsNav } from 'components/ui'
import Stack from 'components/ui/stack'
export const BRIEFING_DETAILS_TAB = 'Briefing details'
export const CHOOSE_RECIPIENTS_TAB = 'Choose Recipients'
export const EMAIL_DETAILS_TAB = 'Email Details'
export const CHOOSE_TEMPLATE_TAB = 'Choose Template'
export const EDIT_CONTENT_TAB = 'Edit Content'
export const CONFIRM_AND_SEND_TAB = 'Confirm and Send'
type CampaignNavSteps =
  | typeof CHOOSE_RECIPIENTS_TAB
  | typeof EMAIL_DETAILS_TAB
  | typeof CHOOSE_TEMPLATE_TAB
  | typeof EDIT_CONTENT_TAB
  | typeof CONFIRM_AND_SEND_TAB
  | typeof BRIEFING_DETAILS_TAB

function mapStateToProps(
  state: State,
  ownProps: {
    campaignId?: string
  },
): any {
  return {
    campaign: ownProps.campaignId
      ? getCampaign(state, {
          campaignId: parseInt(ownProps.campaignId),
        })
      : null,
    validCampaignSteps: getValidCampaignSteps(state, ownProps.campaignId),
  }
}

const mapDispatchToProps = {
  campaignDetailsUpdate,
}

class CampaignNav extends React.Component<{
  campaign: EmailCampaign | null | undefined
  campaignDetailsUpdate: typeof campaignDetailsUpdate
  activeStep: CampaignNavSteps
  validCampaignSteps: {
    validSubject: boolean
    validRecipients: boolean
    validAddress: boolean
    validSender: boolean
    valid: boolean
    validTemplate: boolean
    validContent: boolean
    sendAllowed: boolean
  }
}> {
  _validateStep = (step: CampaignNavSteps) => {
    const {
      validSubject,
      validRecipients,
      validAddress,
      validSender,
      valid,
      validTemplate,
      validContent,
      sendAllowed,
    } = this.props.validCampaignSteps

    switch (step) {
      case CHOOSE_RECIPIENTS_TAB:
        return validRecipients

      case BRIEFING_DETAILS_TAB:
      case EMAIL_DETAILS_TAB:
        return validSubject && validSender && validAddress

      case CHOOSE_TEMPLATE_TAB:
        return validTemplate

      case EDIT_CONTENT_TAB:
        return validContent && sendAllowed

      case CONFIRM_AND_SEND_TAB:
        // we should not ever mark this as done
        return false

      default:
        return true
    }
  }
  _getLink = (step: CampaignNavSteps) => {
    const { campaign } = this.props
    let part
    if (!campaign) return null

    switch (step) {
      case CHOOSE_RECIPIENTS_TAB:
        part = 'recipients'
        break

      case BRIEFING_DETAILS_TAB:
      case EMAIL_DETAILS_TAB:
        part = 'details'
        break

      case CHOOSE_TEMPLATE_TAB:
        part = 'template'
        break

      case EDIT_CONTENT_TAB:
        part = 'editor'
        break

      case CONFIRM_AND_SEND_TAB:
        part = 'confirm'
        break
    }

    if (!part) return
    if (!campaign) return
    return `/campaigns/${campaign.id}/${part}`
  }
  _handleClick = () => {}

  render() {
    const { campaign } = this.props
    let breadcrumbs = null

    if (campaign && !campaign.loading) {
      const { type } = campaign
      let steps = []

      if (type === 'briefing') {
        steps = [
          CHOOSE_RECIPIENTS_TAB,
          BRIEFING_DETAILS_TAB,
          EDIT_CONTENT_TAB,
          CONFIRM_AND_SEND_TAB,
        ]
      } else if (type === 'campaign') {
        steps = [
          CHOOSE_RECIPIENTS_TAB,
          EMAIL_DETAILS_TAB,
          CHOOSE_TEMPLATE_TAB,
          EDIT_CONTENT_TAB,
          CONFIRM_AND_SEND_TAB,
        ]
      }

      breadcrumbs = (
        <Stack>
          <div />
          <TabStepsNav
            items={steps.map((step, index) => {
              const active = this.props.activeStep === step
              const completed = this._validateStep(step) && !active
              return {
                label: `0${index + 1} ${step}`,
                link: this._getLink(step),
                onClick: this._handleClick,
                active,
                completed,
              }
            })}
          />
          <div />
        </Stack>
      )
    }

    return breadcrumbs
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(CampaignNav) as any
